/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".chart-labels[_ngcontent-%COMP%]{position:absolute;pointer-events:none;bottom:25px;width:100%}.chart-label[_ngcontent-%COMP%]{letter-spacing:8px;font-weight:500;font-size:1rem;text-transform:uppercase;width:49.5%;text-align:center;display:inline-block;white-space:nowrap;pointer-events:none}"];
export { styles as styles };
